import { render, staticRenderFns } from "./ClientPage.vue?vue&type=template&id=0ec45084&scoped=true&"
import script from "./ClientPage.vue?vue&type=script&lang=js&"
export * from "./ClientPage.vue?vue&type=script&lang=js&"
import style0 from "./ClientPage.vue?vue&type=style&index=0&id=0ec45084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec45084",
  null
  
)

export default component.exports